import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import MessagesController from './MessagesController';

import panel from '../../services';

import resizeTextArea from '../../directives/resizeTextArea';

import resizeChatArea from '../../directives/resizeChatArea';

import chatIsTyping from '../../directives/chatIsTyping';

export default angular.module('app.dm', [uirouter, panel, resizeTextArea, resizeChatArea, chatIsTyping])
    .config(routing)
    .controller('MessagesController', MessagesController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/inbox/index.js